import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import Logo from "components/logo";
import { useSite } from "hooks/use-site";
import { LoadingButton } from "@mui/lab";
import { useQuery } from "hooks/use-query";
import { confirmEmail } from "service/api";
import { useDebounceEffect } from "ahooks";

const ConfirmEmail = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const [clientId, setClientId] = useState("-");

  const [showPhoneConfirmationButton, setShowPhoneConfirmationButton] =
    useState(false);

  const { logo, frontWalletAuthPageColor } = useSite();

  useDebounceEffect(
    () => {
      const token = query.get("token");
      if (token) {
        confirmEmail(token).then((res) => {
          if (!res.result) {
            navigate("/signin");
          } else {
            setShowPhoneConfirmationButton(res.showPhoneConfirmationButton);
            setClientId(res.clientId);
          }
        });
      } else {
        navigate("/signin");
      }
    },
    [],
    {
      wait: 0,
    }
  );

  return (
    <Box
      display={"flex"}
      alignItems="center"
      justifyContent="cente"
      height={"100vh"}
    >
      <Container maxWidth="sm">
        <Card elevation={24} component={motion.div} layoutId="auth-card">
          <Box
            paddingY={2.5}
            paddingX={4}
            sx={{ bgcolor: `${frontWalletAuthPageColor}` }}
          >
            <Logo src={logo} />
          </Box>
          <CardContent>
            <Stack spacing={4}>
              <Typography variant="subtitle1">
                Thank you for choosing our platform. Your email confirmed.
              </Typography>
              {showPhoneConfirmationButton && (
                <Typography variant="subtitle1">
                  Now need to confirm your phone.
                </Typography>
              )}
              <Stack spacing={2}>
                <Box display="flex">
                  {showPhoneConfirmationButton ? (
                    <LoadingButton
                      onClick={() =>
                        navigate(`/mobile-verification?clientId=${clientId}`)
                      }
                      fullWidth
                      variant="contained"
                    >
                      Mobile Verification
                    </LoadingButton>
                  ) : (
                    <LoadingButton
                      fullWidth
                      variant="contained"
                      onClick={() => navigate("/signin")}
                    >
                      Login
                    </LoadingButton>
                  )}
                </Box>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};
export default ConfirmEmail;
